import { Button, IconButton, Stack } from "@mui/material";

import { removeTax } from "../../../../Api/Signin/Transaction.Api";
import { ReactComponent as Delete } from "../../../../Assets/Images/DeleteOutlined.svg";
import { ReactComponent as Edit } from "../../../../Assets/Images/EditOutlined.svg";
import { ReactComponent as DollarBag } from "../../../../Assets/Images/Icon/DollarBagICON.svg";
import { ReactComponent as TaxBag } from "../../../../Assets/Images/Icon/TAXICON.svg";
import useOverlayState from "../../../../Utils/Hooks/useOverlayState";
import { HorizontalDivide } from "../../../atoms/HorizontalDivide/HorizontalDivide";
import { Heading2, Heading5 } from "../../../atoms/Typography/Heading/Heading";
import { Text } from "../../../atoms/Typography/Text/Text";
import ConfirmDialog from "../../ConfirmDialog/ConfirmDialog";

export const TaxConfiguarationViewContent = ({
  taxLoader,
  setContentID,
  data,
  reset,
  t,
}) => {
  const { OverlayState, openOverlay, closeOverlay } = useOverlayState();
  const removeTaxHandler = async (id) => {
    try {
      if (id) {
        const response = await removeTax({ id: id });
        if (response.type === 0) {
          closeOverlay();
          taxLoader();
        } else {
          closeOverlay();
          taxLoader();
        }
      }
    } catch (exception) {}
  };
  return (
    <>
      <Stack direction={"column"} mb={"20px"} justifyContent={"space-between"}>
        <Heading2 icon={<TaxBag />} text={t('glossary:tax-configuration:tax')} />
        {data.map((item, index) => {
          return (
            <Stack
              key={index}
              direction={"row"}
              spacing={1}
              alignItems={"center"}
              justifyContent={"space-between"}
              ml={"23px"}
              mt={"16px"}
              mb={"18px"}
            >
              <Text icon={<DollarBag />} text={item.name} />

              <Stack direction={"row"} spacing={1}>
                <Heading5 text={item.percentage + "%"} />
                <IconButton
                  style={{ padding: 0 }}
                  onClick={() => {
                    setContentID({
                      sceneID: 1,
                      isUpdate: true,
                      id: item.id,
                    });
                    reset({ tax: item.name, value: item.percentage });
                  }}
                >
                  <Edit id="1" style={{ width: "20px", height: "20px" }}  aria-label="Edit Image"/>
                </IconButton>
                <IconButton
                  style={{ padding: 0 }}
                  onClick={() => {
                    openOverlay({ record: item.id, OverlayName: "delete-tax" });
                  }}
                >
                  <Delete id="2" width={"20px"} aria-label="Delete Image"/>
                </IconButton>
              </Stack>
            </Stack>
          );
        })}
        <Stack>
          <HorizontalDivide height={"0.5px"} marginBottom={"12px"} />
        </Stack>
        <Button
          onClick={() => {
            setContentID({
              sceneID: 1,
              isUpdate: false,
            });
          }}
          variant="primaryBlue"
          sx={{ maxHeight: "50px" }}
        >
          {t('glossary:tax-configuration:add-tax-button')}
        </Button>
      </Stack>
      {OverlayState.OverlayName === "delete-tax" && (
        <ConfirmDialog
          open={OverlayState.visible}
          close={closeOverlay}
          title={t('glossary:tax-configuration:delete-tax')}
          description={t('common:alert-confirm:proceed-confirm')}
          onOkClick={() => {
            removeTaxHandler(OverlayState.record);
          }}
          onOkTitle={t('common:alert-confirm:yes')}
          onCancelClick={closeOverlay}
          onCancelTitle={t('common:alert-confirm:no')}
        />
      )}
    </>
  );
};
